import React from 'react'
import FetchApi from '../Helpers/FetchApi'
import img from '../../assets/Calkulator.png'
import "./image.css"
import ParticlesAnimation from '../Helpers/Particles/Particles'
import {Link} from 'react-router-dom'

const Projects = () => {
  return ( <>

  <ParticlesAnimation/>

      <a href="https://calkulator-2022.netlify.app">
      <h1><strong>TRY IT YOURSELF :)</strong> </h1>
      </a>

    <div className="image">
      <img  src={img} alt={"hola"} height={"50px"}></img>

      </div>
      </>
  )
}

export default Projects